import { useEffect } from "react";

const PrivacyPolicy = () => {
  useEffect(() => {
    // Redirect to the Google Doc privacy policy
    window.location.href = "https://docs.google.com/document/d/1xXVYM-2I0cFmUU815_eKQnIUKE1thhTu_ghHo0PPi3k/edit?usp=drivesdk";
  }, []);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Redirecting to Privacy Policy...</h1>
        <p className="text-gray-600">
          If you are not redirected automatically, 
          <a 
            href="https://docs.google.com/document/d/1xXVYM-2I0cFmUU815_eKQnIUKE1thhTu_ghHo0PPi3k/edit?usp=drivesdk"
            className="text-blue-600 underline hover:text-blue-800 ml-1"
            target="_blank"
            rel="noopener noreferrer"
          >
            click here
          </a>.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;